import {daysBetween, isPlanActive} from "../../../helpers/helpers";
import React from "react";

const StatusItem = ({expirationDate, doesNotExpire, hasActiveFreeTrial,
                        freeTrialExpirationDate}) => {
    if (doesNotExpire) {
        return (
            <div className={'status-item status-active'}>
                {i18n.payments.statusActive}
            </div>
        );
    }

    if (hasActiveFreeTrial) {
        return (
            <div className={'status-item status-active'}>
                {i18n.payments.statusActiveFreeTrial}
            </div>
        );
    }

    const hasActivePlan = isPlanActive(expirationDate);
    const daysUntilExpired = daysBetween(new Date(), new Date(expirationDate));

    if (hasActivePlan && daysUntilExpired >= 7) {
        return (
            <div className={'status-item status-active'}>
                {i18n.payments.statusActive}
            </div>
        );
    } else if (hasActivePlan && daysUntilExpired < 7 && daysUntilExpired >= 0) {
        return (
            <div className={'status-item status-about-to-expire'}>
                {i18n.payments.statusActiveAboutToExpire}
            </div>
        );
    } else if (expirationDate) {
        return (
            <div className={'status-item status-expired'}>
                {i18n.payments.statusExpired}
            </div>
        );
    }

    return <></>;
};

export default StatusItem;